export interface CommunityTopic {
  id: string;
  title: string;
  summary: string;
  content: string;
  tag: string;
  author: string;
  replies: number;
  views: number;
  createdAt: string;
}

export const communityTags: string[] = ["全部", "赛事讨论", "游戏攻略", "音乐分享", "美食推荐", "新版本"];

export const communityTopics: CommunityTopic[] = [
  {
    id: "t1",
    title: "星域争霸半决赛这场团战到底谁指挥的？",
    summary: "最后一波大龙团，打野的进场时机我觉得是全场胜负手，来聊聊你的看法。",
    content:
      "刚看完星域争霸职业联赛半决赛，最后一波大龙团真的太精彩了。上路选手先手开团，打野绕后进场直接秒掉对面中单，这波节奏直接把比赛带走。大家觉得这场的最佳选手应该是打野还是中路？欢迎一起复盘每一波关键决策。",
    tag: "赛事讨论",
    author: "峡谷观察员",
    replies: 128,
    views: 5420,
    createdAt: "2 小时前",
  },
  {
    id: "t2",
    title: "求一份四排稳健运营的跳伞落点推荐",
    summary: "老是落地成盒，想学一套稳定的中后期打法，有大佬分享一下吗？",
    content:
      "最近跟着落地成盒王的直播复盘，感觉运营流真的比莽夫流稳太多了。想请教一下大家平时四排的跳伞落点是怎么选的？物资一般怎么分配？决赛圈卡点有什么心得？希望有大佬能分享一套完整的思路。",
    tag: "游戏攻略",
    author: "刚枪小萌新",
    replies: 86,
    views: 3120,
    createdAt: "5 小时前",
  },
  {
    id: "t3",
    title: "深夜电台点歌：有推荐适合雨夜的钢琴曲吗？",
    summary: "晚风姐姐的电台节目太治愈了，想收集一些适合安静夜晚的曲子。",
    content:
      "昨晚听晚风姐姐的深夜电台，被那段钢琴 BGM 治愈到了。想在这里征集一下适合雨夜听的钢琴和纯音乐，我起个头：德彪西的《月光》、久石让的《Summer》。大家还有什么私藏歌单，评论区见。",
    tag: "音乐分享",
    author: "失眠的猫",
    replies: 64,
    views: 2080,
    createdAt: "昨天",
  },
  {
    id: "t4",
    title: "老城区夜市探店，这几家必吃别错过",
    summary: "跟着干饭不出门的直播打卡了老城区夜市，整理了一份避坑清单。",
    content:
      "看了干饭不出门的老城区夜市探店直播，第二天我就去打卡了。总结一下：烤串摊的孜然味很足，甜品铺的芋圆一定要加双份，最里面那家小面其实一般般。整理了一份清单发出来，想去逛的可以先收藏。",
    tag: "美食推荐",
    author: "夜宵特工",
    replies: 52,
    views: 1760,
    createdAt: "昨天",
  },
  {
    id: "t5",
    title: "《黎明之环》首播感受：美术和战斗手感怎么样？",
    summary: "看完首播实况，画面确实惊艳，聊聊大家对新游的第一印象。",
    content:
      "阿黎的《黎明之环》首播我全程追完了。先说优点：开放世界的美术氛围真的很强，光影和天气系统很加分。战斗手感偏厚重，需要一点适应。剧情节奏前期有点慢。大家对新游的第一印象如何？值不值得入？",
    tag: "新版本",
    author: "首发体验官",
    replies: 97,
    views: 3980,
    createdAt: "3 小时前",
  },
  {
    id: "t6",
    title: "世界杯预选赛阵容预测贴，欢迎打脸",
    summary: "老球评解说前先把我的预测阵容放上来，赛后回来复盘看看准不准。",
    content:
      "世界杯预选赛今晚开打，赛前先立个猜测：我觉得中场会启用双后腰加强防守，边路主打速度。锋线可能有一个惊喜首发。贴出来给大家参考，赛后欢迎回来复盘打脸，也欢迎在弹幕里一起为喜欢的球队加油。",
    tag: "赛事讨论",
    author: "战术板",
    replies: 143,
    views: 6120,
    createdAt: "1 小时前",
  },
];

export interface CommunityComment {
  id: string;
  author: string;
  content: string;
  time: string;
}

export const defaultComments: CommunityComment[] = [
  { id: "c1", author: "路过的观众", content: "分析得很到位，学到了！", time: "10 分钟前" },
  { id: "c2", author: "弹幕小能手", content: "这个观点我赞成，确实是这样。", time: "8 分钟前" },
  { id: "c3", author: "深夜蹲直播", content: "蹲一个后续更新，坐等大佬补充。", time: "5 分钟前" },
];